import * as R from 'ramda';

import AssetsList from '@atom/components/mapPortal/drawerContent/AssetsList';
import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';

import { useListView } from '../hooks/listViewHook';
import { initialState } from '../hooks/mapDataHook';

const AssetsListWrapper = () => {
  const [listView = initialState] = useListView();
  const [{ id: idParam }, { updateSearchParams }] = useNavigation({
    id: SearchParamType.ARRAY,
    view: SearchParamType.STRING,
  });

  const assets = R.pipe(
    R.propOr([], 'assets'),
    // @ts-ignore
    R.filter(R.propSatisfies(R.includes(R.__, idParam), 'id')),
    // @ts-ignore
  )(listView);

  const onClick = id => {
    updateSearchParams({ id, view: 'asset' });
  };
  // @ts-ignore
  return <AssetsList assets={assets} navigateToAsset={onClick} />;
};

export default AssetsListWrapper;
